import BaseState from "Engine/base/states/BaseState";

export default class WaitUserInteractionState extends BaseState {
}
